import React from "react";
import Svg, { Path } from "react-native-svg";
import AppTheme from "../../../AppTheme";

export default function PartiallyCheckedIcon({
  size,
  color = AppTheme.DEFAULT_COLOR,
}) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM3.48864 7.56818C3.16857 7.56818 2.9091 7.82765 2.9091 8.14773C2.9091 8.4678 3.16857 8.72727 3.48864 8.72727H12.5114C12.8314 8.72727 13.0909 8.4678 13.0909 8.14773C13.0909 7.82765 12.8314 7.56818 12.5114 7.56818H3.48864Z"
        fill={color}
      />
    </Svg>
  );
}
